import Vue from 'vue'
import Router from 'vue-router'
import ArchiveEstimates from './views/ArchiveEstimates'
import NewEstimates from './views/NewEstimates'
// import NewSales from './views/NewSales'
import ArchiveSales from './views/ArchiveSales'
import NewReturn from './views/NewReturn'
import ArchiveReturn from './views/ArchiveReturn'
import SingleEstimate from './views/SingleEstimate'
import SingleSales from './views/SingleSales'
import SingleReturn from './views/SingleReturn'
import ArchiveOrders from './views/ArchiveOrders'
import SingleOrders from './views/SingleOrders'
import NewOrders from './views/NewOrders'
import ArchiveInvoices from './views/ArchiveInvoices'
import SingleInvoices from './views/SingleInvoices'
import ArchivePayments from './views/ArchivePayments'
import SinglePayments from './views/SinglePayments'
import ArchiveStock from './views/ArchiveStock'
import ArchiveInventories from './views/ArchiveInventories'
import CheckInventories from './views/CheckInventories'
import ArchiveBudgets from './views/ArchiveBudgets'
import SingleBudget from './views/SingleBudget'
import NewBudget from './views/NewBudget'
import CostBudget from './views/CostBudget'
import ArchiveAccountsReceivable from './views/ArchiveAccountsReceivable'
import ArchiveAccountsPayable from './views/ArchiveAccountsPayable'
import NewReplacement from './views/NewReplacement'
import ArchiveReplacement from './views/ArchiveReplacement'
import SingleReplacement from './views/SingleReplacement'
import NewConsignmentReturn from './views/NewConsignmentReturn'
import ArchiveConsignmentReturn from './views/ArchiveConsignmentReturn'
import SingleConsignmentReturn from './views/SingleConsignmentReturn'
import ConsignmentStockReturn from './views/ConsignmentStockReturn'
// 仕入管理
// import ArchiveWithdrawal from './views/ArchiveWithdrawal'
// import SingleWithdrawal from './views/SingleWithdrawal'
import ArchivePurchase from './views/purchase/ArchivePurchase'
import NewPurchase from './views/purchase/NewPurchase'
import SinglePurchase from './views/purchase/SinglePurchase'
import ArchivePurchasePayments from './views/purchase/ArchivePurchasePayments'
import SinglePurchasePayments from './views/purchase/SinglePurchasePayments'
import ArchivePurchaseStockings from './views/purchase/ArchivePurchaseStockings'
import SinglePurchaseStockings from './views/purchase/SinglePurchaseStockings'
import SinglePurchaseOverseasStockings from './views/purchase/SinglePurchaseOverseasStockings'
// 各種集計
import UserLogin from './views/users/UserLogin'
import UserLoginReset from './views/users/UserLoginReset'
// アカウント管理
import ArchiveUsers from './views/users/ArchiveUsers'
import SingleUsers from './views/users/SingleUsers'

import EdiTool from './views/edi/EdiTool.vue'
import AmazonPayRecv from './views/AmazonPayRecv.vue'

import InoutDetails from './views/InoutDetails.vue'

// 倉庫ユーザーアカウント管理
import ArchiveWarehouseUsers from './views/warehouse_users/ArchiveWarehouseUsers'
import SingleWarehouseUsers from './views/warehouse_users/SingleWarehouseUsers'
import WarehouseUserLogin from './views/warehouse_users/WarehouseUserLogin'
import WarehouseUserPasswordReset from './views/warehouse_users/WarehouseUserPasswordReset'

// 出荷指示
import ShippingInstructions from './views/ShippingInstructions'

import PrintReturn from './views/PrintReturn'
import ArchivePurchaseOverseasStockings from './views/purchase/ArchivePurchaseOverseasStockings'

import ArchiveReserves from './views/ArchiveReserves'
import NewReserves from './views/NewReserves'
import SingleReserves from './views/SingleReserves'

const Dashboard = () => import('./views/Dashboard')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: ArchiveEstimates,
      meta: { title: '見積一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-estimates',
      name: 'archive-estimates',
      component: ArchiveEstimates,
      meta: { title: '見積一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-estimate',
      name: 'single-estimate',
      component: SingleEstimate,
      meta: { title: '見積詳細 | 見積一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-estimates',
      name: 'new-estimates',
      component: NewEstimates,
      meta: { title: '見積登録 | 見積一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    // {
    //   path: '/new-sales',
    //   name: 'new-sales',
    //   component: NewSales,
    //   meta: { title: '売上登録 | 売上一覧 | 販売管理' },
    //   beforeEnter: (to, from, next) => {
    //     document.title = to.meta.title
    //     next()
    //   }
    // },
    {
      path: '/single-sales',
      name: 'single-sales',
      component: SingleSales,
      meta: { title: '売上詳細 | 売上一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-sales',
      name: 'archive-sales',
      component: ArchiveSales,
      meta: { title: '売上一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-return',
      name: 'new-return',
      component: NewReturn,
      meta: { title: '新規返品処理 | 返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-return',
      name: 'archive-return',
      component: ArchiveReturn,
      meta: { title: '返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-return/prints/',
      name: 'archive-return-prints',
      component: PrintReturn,
      meta: { title: '返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-return',
      name: 'single-return',
      component: SingleReturn,
      meta: { title: '返品詳細 | 返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-replacement',
      name: 'new-replacement',
      component: NewReplacement,
      meta: { title: '新規交換品処理 | 交換品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-replacement',
      name: 'archive-replacement',
      component: ArchiveReplacement,
      meta: { title: '交換品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-replacement',
      name: 'single-replacement',
      component: SingleReplacement,
      meta: { title: '交換品詳細 | 交換品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-consignment-return',
      name: 'new-consignment-return',
      component: NewConsignmentReturn,
      meta: { title: '新規委託返品処理 | 委託返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-consignment-return',
      name: 'archive-consignment-return',
      component: ArchiveConsignmentReturn,
      meta: { title: '委託返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-consignment-return',
      name: 'single-consignment-return',
      component: SingleConsignmentReturn,
      meta: { title: '委託返品詳細 | 委託返品一覧 | 返品管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/consignment-stock-return',
      name: 'consignment-stock-return',
      component: ConsignmentStockReturn,
      meta: { title: '委託在庫の戻り | 在庫管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-orders',
      name: 'archive-orders',
      component: ArchiveOrders,
      meta: { title: '受注一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-orders',
      name: 'single-orders',
      component: SingleOrders,
      meta: { title: '受注詳細 | 受注一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-orders',
      name: 'new-orders',
      component: NewOrders,
      meta: { title: '受注登録 | 受注一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-invoices',
      name: 'archive-invoices',
      component: ArchiveInvoices,
      meta: { title: '請求一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-invoices',
      name: 'single-invoices',
      component: SingleInvoices,
      meta: { title: '請求詳細 | 請求一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-payments',
      name: 'archive-payments',
      component: ArchivePayments,
      meta: { title: '入金一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-payments',
      name: 'single-payments',
      component: SinglePayments,
      meta: { title: '入金詳細 | 入金一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-stock',
      name: 'archive-stock',
      component: ArchiveStock,
      meta: { title: '在庫一覧 | 在庫管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/inventories',
      name: 'inventories',
      component: ArchiveInventories,
      meta: { title: '棚卸し | 在庫管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/check-inventories',
      name: 'check-inventories',
      component: CheckInventories,
      meta: { title: '棚卸し | 在庫管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-budget',
      name: 'archive-budget',
      component: ArchiveBudgets,
      meta: { title: '予算一覧 | 予算管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-budget',
      name: 'single-budget',
      component: SingleBudget,
      meta: { title: '予算詳細 | 予算一覧 | 予算管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-budget',
      name: 'new-budget',
      component: NewBudget,
      meta: { title: '予算登録 | 予算一覧 | 予算管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/cost-budget',
      name: 'cost-budget',
      component: CostBudget,
      meta: { title: '配送コスト入力 | 予算管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-accounts-receivable',
      name: 'archive-accounts-receivable',
      component: ArchiveAccountsReceivable,
      meta: { title: '売掛一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-accounts-payable',
      name: 'archive-accounts-payable',
      component: ArchiveAccountsPayable,
      meta: { title: '買掛一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    // {
    //   path: '/archive-withdrawal',
    //   name: 'archive-withdrawal',
    //   component: ArchiveWithdrawal,
    //   meta: { title: '出金一覧 | 仕入管理' },
    //   beforeEnter: (to, from, next) => {
    //     document.title = to.meta.title
    //     next()
    //   }
    // },
    // {
    //   path: '/single-withdrawal',
    //   name: 'single-withdrawal',
    //   component: SingleWithdrawal,
    //   meta: { title: '出金詳細 | 出金一覧 | 仕入管理' },
    //   beforeEnter: (to, from, next) => {
    //     document.title = to.meta.title
    //     next()
    //   }
    // },
    {
      path: '/archive-purchases',
      name: 'archive-purchases',
      component: ArchivePurchase,
      meta: { title: '発注一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/new-purchases',
      name: 'new-purchases',
      component: NewPurchase,
      meta: { title: '発注登録 | 発注一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-purchases',
      name: 'single-purchases',
      component: SinglePurchase,
      meta: { title: '発注詳細 | 発注一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-purchase-stockings',
      name: 'archive-purchase-stockings',
      component: ArchivePurchaseStockings,
      meta: { title: '国内入荷の一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-purchase-overseas-stockings',
      name: 'archive-purchase-overseas-stockings',
      component: ArchivePurchaseOverseasStockings,
      meta: { title: '海外仕入れの一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-purchase-stockings',
      name: 'single-purchase-stockings',
      component: SinglePurchaseStockings,
      meta: { title: '国内入荷詳細 | 国内入荷の一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-purchase-overseas-stockings',
      name: 'single-purchase-overseas-stockings',
      component: SinglePurchaseOverseasStockings,
      meta: { title: '海外仕入れ詳細 | 海外仕入れの一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-purchase-payments',
      name: 'archive-purchase-payments',
      component: ArchivePurchasePayments,
      meta: { title: '支払一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-purchase-payments',
      name: 'single-purchase-payments',
      component: SinglePurchasePayments,
      meta: { title: '支払詳細 | 支払一覧 | 仕入管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { title: '売上集計 | 各種集計' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/login',
      name: 'login',
      component: UserLogin,
      meta: { title: 'ログイン', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/login-reset',
      name: 'login-reset',
      component: UserLoginReset,
      meta: { title: 'パスワード再発行', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-users',
      name: 'archive-users',
      component: ArchiveUsers,
      meta: { title: 'ユーザ一覧 | アカウント管理', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-users',
      name: 'single-users',
      component: SingleUsers,
      meta: { title: 'ユーザ詳細 | ユーザ一覧 | アカウント管理', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/edi-tool',
      name: 'edi-tool',
      component: EdiTool,
      meta: { title: 'EDIツール', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/amazon-payrecv',
      name: 'amazon-payrecv',
      component: AmazonPayRecv,
      meta: { title: 'Amazon買掛売掛管理', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/inout-details',
      name: 'inout-details',
      component: InoutDetails,
      meta: { title: '入出庫明細', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-warehouse-users',
      name: 'archive-warehouse-users',
      component: ArchiveWarehouseUsers,
      meta: { title: '倉庫ユーザー一覧', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/single-warehouse-users',
      name: 'single-warehouse-users',
      component: SingleWarehouseUsers,
      meta: { title: '倉庫ユーザー詳細', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/warehouse-login',
      name: 'warehouse-login',
      component: WarehouseUserLogin,
      meta: { title: '倉庫ユーザーログイン', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/warehouse-password-reset',
      name: 'warehouse-password-reset',
      component: WarehouseUserPasswordReset,
      meta: { title: '倉庫ユーザーパスワード再発行', headerType: 'ryoma' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/shipping-instructions',
      name: 'shipping-instructions',
      component: ShippingInstructions,
      meta: { title: '出荷指示' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    {
      path: '/archive-reserves',
      name: 'archive-reserves',
      component: ArchiveReserves,
      meta: { title: '取置の一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    },
    // {
    //   path: '/new-reserves',
    //   name: 'new-reserves',
    //   component: NewReserves,
    //   meta: { title: '取置の登録 | 取置の一覧 | 販売管理' },
    //   beforeEnter: (to, from, next) => {
    //     document.title = to.meta.title
    //     next()
    //   }
    // },
    {
      path: '/single-reserves',
      name: 'single-reserves',
      component: SingleReserves,
      meta: { title: '取置の詳細 | 取置の一覧 | 販売管理' },
      beforeEnter: (to, from, next) => {
        document.title = to.meta.title
        next()
      }
    }
  ]
})
